import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { CicloI } from "interfaces/Ciclo";
import { NivelI } from "interfaces/Nivel";
import { Dropdown } from "react-bootstrap";
import { deleteCiclo } from "services/ciclo";
import { deleteNiveles } from "services/niveles";

interface Props {
  elemento: CicloI;
  onClickEdit: (elemento: CicloI) => void;
  refreshTable: () => void;
}

export const CicloRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteCiclo(id);
      showSuccessToast("¡El ciclo fue eliminado con éxito!");
      refreshTable();
    } catch (error) {
      showErrorToast("Error eliminando el ciclo");
    }
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar ciclo"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar el Ciclo {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
